import { useCallback, useEffect, useRef, useState } from 'react'

import { QueryClient, useQueryClient } from '@tanstack/react-query'

type useBlickPlusOnboardingCurrentStepType = () => number

const getBlickPlusOnboardingCurrentStep = (queryClient: QueryClient): number =>
  queryClient.getQueryData<number>(['blick-plus-onboarding-current-step']) ?? -1

const useBlickPlusOnboardingCurrentStep: useBlickPlusOnboardingCurrentStepType =
  () => {
    const queryClient = useQueryClient()
    const queryCache = queryClient.getQueryCache()
    const [currentStepIndex, setCurrentStepIndex] = useState(-1)
    const unsubscribeFnRef = useRef<() => void>(undefined)

    const updateCurrentStep = useCallback(
      (args: any) => {
        if (
          args?.action?.type === 'invalidate' &&
          args.query.queryKey[0] === 'blick-plus-onboarding-current-step'
        ) {
          setCurrentStepIndex(getBlickPlusOnboardingCurrentStep(queryClient))
        }
      },
      [queryClient],
    )

    useEffect(() => {
      unsubscribeFnRef.current = queryCache.subscribe(updateCurrentStep)

      setCurrentStepIndex(getBlickPlusOnboardingCurrentStep(queryClient))

      return () => {
        if (unsubscribeFnRef.current) {
          unsubscribeFnRef.current()
        }
      }
    }, [queryCache, queryClient, updateCurrentStep])

    return currentStepIndex
  }

export default useBlickPlusOnboardingCurrentStep
